import { MapPin, X } from 'lucide-react';
import { assetUrl } from '../../lib/upload';

type Punch = { at?: string | null; selfieUrl?: string | null; lat?: string | null; lng?: string | null };

function time(v?: string | null) { return v ? new Date(v).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }) : null; }

function Panel({ label, punch }: { label: string; punch: Punch }) {
  if (!punch.selfieUrl) {
    return (
      <div className="flex-1">
        <p className="text-sm font-semibold text-muted">{label}</p>
        <div className="mt-2 flex aspect-square items-center justify-center rounded-xl bg-canvas text-sm text-muted">Not punched</div>
      </div>
    );
  }
  return (
    <div className="flex-1">
      <p className="text-sm font-semibold text-muted">{label}{time(punch.at) ? ` • ${time(punch.at)}` : ''}</p>
      <img src={assetUrl(punch.selfieUrl)} alt={`${label} selfie`} className="mt-2 aspect-square w-full rounded-xl border border-border object-cover" />
      {punch.lat && punch.lng && (
        <a href={`https://www.google.com/maps?q=${punch.lat},${punch.lng}`} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-brand-700">
          <MapPin size={14} /> View location
        </a>
      )}
    </div>
  );
}

/** How a manager verifies a check-in is genuine (SoW §5.2): the selfie plus a link to the GPS
 * point it was taken at, side by side for check-in and check-out. */
export function SelfieViewerModal({ title, subtitle, checkIn, checkOut, onClose }: { title: string; subtitle?: string; checkIn: Punch; checkOut: Punch; onClose: () => void }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div className="w-full max-w-lg rounded-2xl bg-white p-5 shadow-card" onClick={(e) => e.stopPropagation()}>
        <div className="mb-4 flex items-start justify-between gap-3">
          <div><h3 className="font-bold">{title}</h3>{subtitle && <p className="text-sm text-muted">{subtitle}</p>}</div>
          <button type="button" aria-label="Close" onClick={onClose} className="text-muted hover:text-ink"><X size={20} /></button>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Panel label="Check-in" punch={checkIn} />
          <Panel label="Check-out" punch={checkOut} />
        </div>
      </div>
    </div>
  );
}
